var exports = {
  "Nr": "x234b8571--271f29--card",
  "$_": "x234b8571--271f29--media",
  "j$": "x234b8571--271f29--image-list",
  "e1": "x234b8571--271f29--image-item",
  "AP": "x234b8571--271f29--image-more",
  "DD": "x234b8571--271f29--title",
  "DY": "x234b8571--271f29--reliable",
  "O9": "x234b8571--271f29--finish",
  "OM": "x234b8571--271f29--subway",
  "WR": "x234b8571--271f29--apartments",
  "xy": "x234b8571--271f29--info-buttons",
  "zH": "x234b8571--271f29--details",
};

module.exports = exports;
